var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0013 3.33301H5.0013C3.16797 3.33301 1.66797 4.83301 1.66797 6.66634V26.6663C1.66797 28.4997 3.16797 29.9997 5.0013 29.9997H16.668V33.333H15.0013C14.0846 33.333 13.3346 34.083 13.3346 34.9997C13.3346 35.9163 14.0846 36.6663 15.0013 36.6663H25.0013C25.918 36.6663 26.668 35.9163 26.668 34.9997C26.668 34.083 25.918 33.333 25.0013 33.333H23.3346V29.9997H35.0013C36.8346 29.9997 38.3346 28.4997 38.3346 26.6663V6.66634C38.3346 4.83301 36.8346 3.33301 35.0013 3.33301ZM33.3346 26.6663H6.66797C5.7513 26.6663 5.0013 25.9163 5.0013 24.9997V8.33301C5.0013 7.41634 5.7513 6.66634 6.66797 6.66634H33.3346C34.2513 6.66634 35.0013 7.41634 35.0013 8.33301V24.9997C35.0013 25.9163 34.2513 26.6663 33.3346 26.6663Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopIcon);
export default __webpack_public_path__ + "static/media/DesktopIcon.3564225ffd6e9ebffbd9c7f7c7af38d1.svg";
export { ForwardRef as ReactComponent };